/**
 * Maps an Importing Status row key to the ETL resource that force sync must re-extract.
 *
 * Most rows are named after their own ETL resource, so they map to themselves. The
 * "Inventory On Hand" row is the exception: it is rendered under the key `inventory_on_hand`
 * but is fed by the `inventory_levels` extract, so it needs an explicit mapping.
 * `GET /etl/trigger_incremental?resources=` accepts the resource names the extract trigger
 * routes to a queue (`extract_inventory_levels`, `extract_inventory_level_quantities`, …).
 */
const ROW_KEY_TO_ETL_RESOURCE: { [rowKey: string]: string } = {
  inventory_on_hand: 'inventory_levels',
};

export function forceSyncResourceKey(rowKey: string): string {
  return ROW_KEY_TO_ETL_RESOURCE[rowKey] || rowKey;
}
